import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { MailX, BarChart3, FileWarning, Network } from 'lucide-react';
const problems = [{
  icon: <MailX className="w-8 h-8 text-neon-red" data-id="element-221" />,
  title: 'Endless Cold Outreach',
  desc: 'Teams waste months cold-emailing brands with generic decks, rarely getting a response or feedback.'
}, {
  icon: <BarChart3 className="w-8 h-8 text-neon-red" data-id="element-222" />,
  title: 'Unverified Audiences',
  desc: 'Brands struggle to verify actual team reach, engagement rates, and audience demographics before signing.'
}, {
  icon: <FileWarning className="w-8 h-8 text-neon-red" data-id="element-223" />,
  title: 'Opaque Deal Terms',
  desc: 'Without standard pricing, teams often undervalue themselves while brands overpay for underperforming assets.'
}, {
  icon: <Network className="w-8 h-8 text-neon-red" data-id="element-224" />,
  title: 'Fragmented Market',
  desc: 'No centralized marketplace exists. Everything happens through messy Twitter DMs and expensive middlemen.'
}];
export function Problems() {
  return <section className="py-24 bg-dark relative overflow-hidden" data-id="element-225">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-neon-red/5 rounded-full blur-[100px] pointer-events-none" data-id="element-226" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-227">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-228">
          <h2 className="font-rajdhani text-4xl md:text-5xl font-bold mb-6" data-id="element-229">
            THE <span className="text-neon-red text-glow-red" data-id="element-230">BROKEN</span>{' '}
            SPONSORSHIP LANDSCAPE
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-231">
            The current system is built on guesswork, hidden fees, and wasted
            time. It's time for an upgrade.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-232">
          {problems.map((prob, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-dark-card border border-white/5 p-8 rounded-xl hover:border-neon-red/30 transition-colors group relative overflow-hidden" data-id="element-233">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-neon-red/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-234" />
              <div className="mb-6 p-4 bg-dark rounded-lg inline-block border border-white/5 group-hover:border-neon-red/20 transition-colors" data-id="element-235">
                {prob.icon}
              </div>
              <h3 className="font-rajdhani text-2xl font-bold mb-3" data-id="element-236">
                {prob.title}
              </h3>
              <p className="text-gray-400 leading-relaxed text-sm" data-id="element-237">
                {prob.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}